import {
    DistratosDigitalizados,
    DistratosDigitalizadosCreateForm,
    DistratosDigitalizadosTrash
} from "./digitalizados"

export {default as Distratos} from "./Distratos"
export {default as DistratosEditForm} from "./DistratosEditForm"
export {default as DistratosCreateForm} from "./DistratosCreateForm"
export {default as TableDistratos} from "./TableDistratos"
export {
    DistratosDigitalizados,
    DistratosDigitalizadosCreateForm,
    DistratosDigitalizadosTrash
}


// WEBPACK FOOTER //
// ./src/views/distratos/index.js